import type { RouterClient } from "@orpc/server";
import type { ExtendedAppRouter } from "./router";

export type GlobalAppClient = RouterClient<ExtendedAppRouter>;

const globalClientStore = globalThis as typeof globalThis & {
  $client?: GlobalAppClient;
};

export function getGlobalClient(): GlobalAppClient | undefined {
  return globalClientStore.$client;
}

export function setGlobalClient(client: GlobalAppClient): void {
  globalClientStore.$client = client;
}
